import { Flex, Image } from "antd";
import defaultLogo from "assets/paldock_logo-auth.svg";
import { useAuthLayout } from "components/Layouts/AuthLayout/AuthLayoutContext.tsx";
import { AuthButton } from "components/UI/AuthButton/AuthButton.tsx";
import { PropsWithChildren } from "react";

export type AuthFormWrapperProps = {
    buttonText: string;
    loading?: boolean;
    buttonDisabled?: boolean;
    beforeButton?: React.ReactNode;
    formId?: string;
} & PropsWithChildren;

export const TenantAuthFormWrapper: React.FC<AuthFormWrapperProps> = ({
    children,
    buttonText,
    loading = false,
    buttonDisabled = false,
    beforeButton,
    formId,
}) => {
    const { logo } = useAuthLayout();
    return (
        <div className="flex gap-2 flex-col w-full">
            <Flex justify="center" className="my-4">
                <Image src={logo ?? defaultLogo} width="75%" preview={false} alt="Logo" />
            </Flex>
            {children}
            {beforeButton}
            <div className="mt-4">
                <AuthButton loading={loading} disabled={buttonDisabled} form={formId}>
                    {buttonText}
                </AuthButton>
            </div>
        </div>
    );
};
